import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

// Main columns configuration
export const emergencySuppliesCols = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    "Water Supply": [
      {
        title: "Amount Per Person",
        dataIndex: "Amount Per Person",
        key: "amountperperson",
      },
      {
        title: "Storage Location",
        dataIndex: "Storage Location",
        key: "storagelocation",
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Food Inventory": [
      {
        title: "Quantities",
        dataIndex: "Quantities",
        key: "quantities",
      },
      {
        title: "Storage Location",
        dataIndex: "Storage Location",
        key: "storagelocation",
      },
      {
        title: "Types",
        dataIndex: "Types",
        key: "types",
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Special Dietary Needs": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Dietary Needs",
        dataIndex: "Dietary Needs",
        key: "dietaryneeds",
      },
      actionColumn,
    ],
    "Medical Devices and Supplies": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      actionColumn,
    ],
    "First Aid Kit Information": [
      {
        title: "First Aid Kit Name",
        dataIndex: "First Aid Kit Name",
        key: "firstaidkitname",
      },
      {
        title: "Contents",
        dataIndex: "Contents",
        key: "contents",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      actionColumn,
    ],
    "Prescription Medications": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Who's Prescription",
        dataIndex: "Who's Prescription",
        key: "who's prescription",
      },
      {
        title: "Dosage",
        dataIndex: "Dosage",
        key: "dosage",
      },
      {
        title: "Frequency",
        dataIndex: "Frequency",
        key: "frequency",
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expiration date",
      },
      actionColumn,
    ],
    "Emergency Equipment": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      actionColumn,
    ],
    Flashlights: [
      {
        title: "Number",
        dataIndex: "Number",
        key: "number",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      actionColumn,
    ],
    Batteries: [
      {
        title: "Number",
        dataIndex: "Number",
        key: "number",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      {
        title: "Size",
        dataIndex: "Size",
        key: "size",
      },
      actionColumn,
    ],
    Radio: [
      {
        title: "Power Method",
        dataIndex: "Power Method",
        key: "power method",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      actionColumn,
    ],
    "Phone Chargers": [
      {
        title: "For Which Device",
        dataIndex: "For Which Device",
        key: "for which device",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },
      {
        title: "Length",
        dataIndex: "Length",
        key: "length",
      },
      actionColumn,
    ],
    "Clothing and Bedding": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },

      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },

      {
        title: "For Whom",
        dataIndex: "For Whom",
        key: "for whom",
      },
      actionColumn,
    ],
    "Cash Emergency Supplies Inventory": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },

      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
    ],
  };
};

// Usage example in your component:
// const { viewModal, updateModal, deleteRecord } = yourPropsOrContext;
// const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);
